import React, { useEffect, useState } from 'react';
import type { Team } from '../../../../types';
import { teamService } from '../../services/teamService';

/** 团队所有者/管理员：设置企业微信或飞书机器人，agent 交付或受阻时推送 */
export const NotifySettings: React.FC<{ team: Team }> = ({ team }) => {
  const [masked, setMasked] = useState<string | null>(null);
  const [url, setUrl] = useState('');
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState<{ ok: boolean; text: string } | null>(null);

  useEffect(() => {
    setMsg(null);
    teamService.getNotify(team.id).then(r => setMasked(r.configured ? r.masked : null)).catch(() => setMsg({ ok: false, text: '加载通知设置失败' }));
  }, [team.id]);

  const run = async (action: () => Promise<void>, okText: string) => {
    setBusy(true);
    setMsg(null);
    try {
      await action();
      setMsg({ ok: true, text: okText });
    } catch (e: any) {
      setMsg({ ok: false, text: e?.response?.data?.message || '操作失败，请重试' });
    } finally {
      setBusy(false);
    }
  };

  const save = () => run(async () => {
    const r = await teamService.setNotify(team.id, url.trim());
    setMasked(r.masked);
    setUrl('');
  }, '已保存');

  const clear = () => run(async () => {
    await teamService.setNotify(team.id, null);
    setMasked(null);
  }, '已关闭通知');

  return (
    <div className="bg-gray-50 rounded-lg p-3">
      <div className="flex items-center justify-between mb-2">
        <h3 className="text-sm font-semibold text-gray-800">通知</h3>
        <span className="text-xs text-gray-400">agent 交付待验收、或受阻时推送</span>
      </div>
      {masked && (
        <div className="flex items-center justify-between gap-2 mb-2 text-xs text-gray-600">
          <code className="truncate">{masked}</code>
          <div className="flex gap-2 shrink-0">
            <button disabled={busy} onClick={() => run(() => teamService.testNotify(team.id), '测试消息已发出')} className="px-2 py-1 rounded bg-white border border-gray-200 hover:bg-gray-50 disabled:opacity-50">发测试消息</button>
            <button disabled={busy} onClick={clear} className="px-2 py-1 rounded bg-white border border-gray-200 text-red-600 hover:bg-gray-50 disabled:opacity-50">关闭</button>
          </div>
        </div>
      )}
      <div className="flex gap-2">
        <input
          value={url}
          onChange={e => setUrl(e.target.value)}
          placeholder="企业微信或飞书群机器人的 webhook 地址"
          className="flex-1 min-w-0 px-2 py-1.5 text-xs border border-gray-200 rounded-md bg-white focus:outline-none focus:border-blue-500"
        />
        <button disabled={busy || !url.trim()} onClick={save} className="px-3 py-1.5 text-xs rounded-md bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-50">
          {masked ? '替换' : '保存'}
        </button>
      </div>
      {msg && <div className={`mt-2 text-xs ${msg.ok ? 'text-green-600' : 'text-red-600'}`}>{msg.text}</div>}
    </div>
  );
};
